import React, { useEffect, useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as Moment from "moment";
import { readRequesterSession } from "../../../store/requester/thunkAction";
import { useTranslation } from "react-i18next";
// import "moment/locale/vi";

const Session = ({ config }) => {
  const { t } = useTranslation();
  const params = useParams();
  const userId = _.get(params, "id");
  const dispatch = useDispatch();

  const staffManage = useSelector((state) => state.staffManage);
  const requesterManage = useSelector((state) => state.requesterManage);
  const socketManage = useSelector((state) => state.socketManage);

  const [requester, setRequester] = useState({});
  const [isOnline, setIsOnline] = useState(false);

  const requesterStatusChange = _.get(
    socketManage,
    "requesterStatusChange",
    {}
  );
  const requesters = _.get(requesterManage, "requesters");
  const staff = _.get(staffManage, "staff", {});

  const staffId = _.get(staff, "_id");
  const session = _.get(config, "session");
  const isSearch = _.get(config, "isSearch", false);
  const navigate = useNavigate();
  const sessionId = _.get(session, "_id");
  const message = _.get(session, "lastMessage");
  const requesterId = _.get(session, "requesterId");
  const updateTime = _.get(session, "updateTime", 0);
  const staffSeenDetail = _.get(session, "staffSeenDetail", []);
  const staffSeenAt = _.get(
    _.find(staffSeenDetail, { staffId: staffId }),
    "seenAt",
    0
  );

  useEffect(() => {
    if (requesterId && !isSearch) {
      dispatch(readRequesterSession(requesterId));
    }
  }, [dispatch, requesterId, isSearch]);

  useEffect(() => {
    const requesterChangeId = _.get(requesterStatusChange, "requesterId");
    if (requesterChangeId && requesterChangeId === requesterId) {
      dispatch(readRequesterSession(requesterId));
    }
  }, [dispatch, requesterId, requesterStatusChange]);

  useEffect(() => {
    if (requesterId) {
      setRequester(requesters[requesterId] || {});
    }
  }, [dispatch, requesters, requesterId]);

  useEffect(() => {
    if (requester._id) {
      const isOnline = _.get(
        _.find(requester.attributes, { key: "isOnline" }),
        "value",
        false
      );

      setIsOnline(isOnline);
    }
  }, [requester]);

  const timeAgo = (timestamp) => {
    const now = Moment();
    const time = Moment(timestamp);

    if (time.isAfter(now)) {
      return time.from(now);
    }
    return time.fromNow();
  };

  return (
    <div
      onClick={() => {
        navigate(`/chat/${userId}/message/session-id/${sessionId}`);
      }}
      style={{ width: "100%" }}
    >
      {!isSearch ? (
        <div className="d-flex gap-3" style={{ width: "100%" }}>
          <img
            width="20%"
            height="40px"
            className="rounded-circle mt-1"
            src="/img/chat/avatar.png"
            alt=""
            style={{
              maxWidth: "40px",
            }}
          />
          <div style={{ width: "80%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
              className="gap-2 justify-content-between align-items-center mb-1"
            >
              <div className="fw-medium one-line">{_.get(session, "name")}</div>
              <span className="color-gray small">
                {timeAgo(_.get(session, "updateTime"))}
                {staffSeenAt < updateTime && (
                  <span
                    style={{
                      height: "10px",
                    }}
                    className="color-info"
                  >
                    {" "}
                    ●
                  </span>
                )}
              </span>
            </div>
            <div
              className="text-content one-line color-gray"
              style={
                staffSeenAt < updateTime
                  ? {
                      fontWeight: "bold",
                      color: "black",
                      width: "100%",
                    }
                  : { width: "100%" }
              }
            >
              {message || "---"}
            </div>
            <div className="small">
              <span className={isOnline ? "color-info" : "text-warning"}>
                ●
              </span>{" "}
              {isOnline ? t("agent.nav.online") : t("agent.nav.offline")} ·
              {_.get(session, "domain")}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex gap-3 align-items-center"
          style={{ width: "100%" }}
        >
          <img
            width="20%"
            height="40px"
            className="rounded-circle mt-1"
            src="/img/chat/avatar.png"
            alt=""
            style={{
              maxWidth: "40px",
            }}
          />
          <div
            style={{
              width: "80%",
            }}
            className="fw-medium one-line"
          >
            {_.get(session, "name")}
          </div>
        </div>
      )}
    </div>
  );
};

export default Session;
